import { useLocation } from "react-router-dom";

export const useGetUrlParams = (param: string) => {
  const location = useLocation();
  const urlParams = new URLSearchParams(location.search);
  return urlParams.get(param);
};
